<template>
  <div id="content" class="linkplusGenerator">
    <ConnectModal :dialogVisible='dialog.connect' :lp="myLinkPlus" @close="dialog.connect = false" @wantToConnect="connectWithUS($event)" :company_types="available_company_types"/>
    <div class="container" v-if="isExpired">
        <div class="linkplusContent" style="padding:50px;">
        <strong>Thank you for your interest in collaborating with us.</strong>
        <br/><br/>
We have now closed submissions for this challenge. Please stay connected with us or Innopearl, for future opportunities and announcements.
<br/><br/>
Best regards<br/>
<span v-if="myLinkPlus.entreprise">{{myLinkPlus.entreprise}}</span>
      </div>
    </div>

    <div class="container" v-else>

            <div class="linkplusContent">
              <div class="col-12 mylink_banner" v-if='smyLinkPlus_image'>
                   <img :src="apiUrl+'/get_image/'+smyLinkPlus_image" alt="" class="mylink_banner_img" v-if="smyLinkPlus_image">

              </div>
              <div class="row contentOf">

                <div class="myaccountlogo" v-if='myLinkPlus.logo'>
                    <img :src="apiUrl+'/get_image/'+myLinkPlus.logo.$oid"   alt="" class="myaccountlogoImage">
                </div>
                  <div class="startupName">
                    <h1>{{myLinkPlus.name}}</h1>
                    <small v-if="expirationDateFormated">Apply before {{expirationDateDisplayed}}</small>
                  </div>
                  <div class="" v-if="myLinkPlus.status == 'DELETE'">
                    <div class="alert alert-danger text-center">
                    This Link+<sup>©</sup> has been removed
                    </div>
                  </div>
                  <div v-else class="contentOfLinkPlus mt20 mb20" v-html="myLinkPlus.content"></div>

                  <div class="mt20 " v-if="myLinkPlus.status == 'PUBLISHED'">
                    <div class="text-center">
                      <button type="button" class="btn next_step_btn" @click="dialog.connect = true" name="button">Apply</button>
                    </div>
                  </div>
              </div>

              <div class="footer" style="">


              <div id="" class="dlex mt30" >
                  <small><a href="https://www.innopearl.ch/data-policy/" target="_blank">Data Policy</a></small>
                  <small class="absbr">Powered by Innopearl ©</small>
              </div>
              </div>
            </div>

    </div>

  </div>
</template>
<script>
import '@vueup/vue-quill/dist/vue-quill.snow.css';
  import ConnectModal from '@/components/modals/ConnectModal.vue'
 // import NewValueModal from '@/components/modals/addValue.vue'
   // import AddSomeThingLink from '@/components/AddSomeThingLink.vue'
// import BookACall from '@/components/bookacall.vue'
  import { toast } from 'vue-sonner'


export default {
  components: {
ConnectModal
    // AddSomeThingLink
    // Toaster,
    // BookACall
  },
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      pageInfo: {
        mainTitle : "Link plus",
        subTitle : "",
      },
      dialog:{
        image:false,
        connect:false
      },
      toolbarOptions : [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['blockquote', 'code-block'],
        [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
        [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent                  // text direction
        [{ 'header': [1, 2, 3, false] }],
        [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme

        ['clean']                                         // remove formatting button
      ],
      contentHTML:"",
      myLinkPlus : {
        name: "",
        link : null,
        image:null,
        qrcode : null,
        content: '',
        status : "DRAFT"
      },
      available_company_types:[],
      expirationDateFormated:null,
      expirationDateDisplayed: null,
      today: new Date(),
    }
  },
  methods:{
    gobackrouter : function(){
      this.$router.go(-1);
    },
      connectWithUS(v){
        console.log(v);
        this.dialog.connect = false;
        v.linkplus = this.myLinkPlus._id;

        this.axios.post(process.env.VUE_APP_API_URL+"/linkplus_connect_v2",v,{
            headers: {
                'Content-Type': 'application/json',
            }
        }).then( (r) => {
          console.log(r);
          toast.success("Thank you. You'll receive a personalized link via email.");
        }).catch( (e) => {
          console.log(e);
           toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
      });
      },
    isValid(){
      return true;

    },


  },
  computed:{
    smyLinkPlus_image: function(){
      if(this.myLinkPlus.image){
        console.log(this.myLinkPlus.image);
        return this.myLinkPlus.image.$oid;
      }
      else{
        return null;
      }

    },
    isExpired: function(){
      if(this.expirationDateFormated){
          if(this.expirationDateFormated.getTime() < this.today.getTime())return true;
          else return false;
      }
      else{
        return false;
      }
    }

  },

  mounted(){
    this.axios.get(process.env.VUE_APP_API_URL+"/linkplusbyaccessid/"+this.$route.params.aid).then( (r) => {
      this.myLinkPlus = r.data;
      this.pageInfo.mainTitle = this.myLinkPlus.name;
      this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)
      if(this.myLinkPlus.expirationDate){
        this.expirationDateFormated = new Date(this.myLinkPlus.expirationDate.date.split(' ')[0])
        this.expirationDateDisplayed =this.myLinkPlus.expirationDate.date.split(' ')[0];
        var te  =this.expirationDateDisplayed.split('-');
        this.expirationDateDisplayed = te[2]+"/"+te[1]+"/"+te[0]
      }
      else{
        this.expirationDateFormated = null;
        this.expirationDateDisplayed = null;
      }
      if(this.myLinkPlus?.open_to == "other"){
          this.available_company_types = [];
          this.axios.get(process.env.VUE_APP_API_URL+"/all_startup_company_type").then( (r) => {
            console.log(r);
            this.available_company_types = r.data;
          }).catch( (e) => {
            console.log(e);
             toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
          });
      }
      else{
        this.available_company_types = [];
        this.axios.get(process.env.VUE_APP_API_URL+"/only_startup_company_type").then( (r) => {
          console.log(r);
          this.available_company_types = r.data;
        }).catch( (e) => {
          console.log(e);
           toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
      }
      console.log(r);
    }).catch( (e) => {
      console.log(e);
       toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
    });
   },
}
</script>
<style scoped >
.dlex{
  display:flex;
  flex-direction: row;
  gap:10px;
  justify-content: center;
  align-items: center;
  align-content: center;
}
.linkplusGenerator{
  padding-top:50px;
  padding-bottom: 50px;
}
.linkplusContent{
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;


}
.startupName{
  width:100%;
  /* color:#4C81C0; */
  font-weight: bold;
    padding:0px;
    margin-top:10px;

  background:#FFF;
  text-align:center;
  display:flex;
  flex-direction: column;
}
.startupName > h1{
      font-size: 25px;
}
.contentOf{
  padding:70px;
  padding-top:40px;
}

.mylink_banner{
  position:relative;
  height:500px;
  background:#EFEFEF;
  padding: 0 !important;
  position:relative;
}
.mylink_banner img.mylink_banner_img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.mt20{
  margin-top:20px;
}
.mb20{
  margin-bottom: 20px;
}
.myaccountlogo{
  /* position: absolute;

    top:50px;
    right:50px; */
    padding: 10px;
    background: #FFF;
    /* border:1px solid #DDD; */
    /* -webkit-box-shadow: 0px 0px 20px -4px #CCC;
    box-shadow:0px 0px 20px -4px #CCC; */
    width: auto;
  margin: auto;
}


.myaccountlogoImage{
  width:200px;
  height:100px;
  object-fit: contain;
  object-position:  center;
  margin: auto;
}
.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}

.mt30{
  margin-top:30px;
}

.footer{
  padding:0px 50px;padding-bottom:20px;text-align:center;

  position:relative;
}
.footer small{
  display:block;
}
.footer a{
  color:inherit;
}
.row > * {
  padding-right: 0;
  padding-left: 0;
}
.absbr{
  position:absolute;
  bottom:20px;
  right:20px;
  color:#3783C5;
}

.contentOfLinkPlus{
  margin-top:50px;
}

@media screen and (max-width:690px){
  .contentOf{
    padding:30px 30px;
  }
  .dlex{
    flex-direction: column;
  }
.absbr{
  position:relative;
  bottom: auto;
    right: auto;
}
.mylink_banner {
  position: relative;
  height: 250px;
  background: #EFEFEF;
  padding: 0 !important;
  position: relative;
}

}



</style>
<style media="screen">
  .ql-editor{
    min-height:300px;
  }
  .contentOfLinkPlus p{
    margin-bottom:10px !important;
      padding:0px !important;
  }

  .ql-font-monospace{
    font-family: "Monaco", "Courier New", "monospace" !important;
  }
  .ql-font-serif {
    font-family: "Georgia", "Times New Roman", "serif" !important;
  }



  .ql-font-Oswald{
        font-family: 'Oswald' !important;
  }
  .ql-font-Merriweather{
        font-family: 'Merriweather' !important;
  }
  .ql-font-Ubuntu{
          font-family: 'Ubuntu' !important;
  }
  .ql-font-Raleway{
          font-family: 'Raleway' !important;
  }
  .ql-font-Poppins{
          font-family: 'Poppins' !important;
  }
  .ql-font-Montserrat{
          font-family: 'Montserrat' !important;
  }
  .ql-font-Lato{
          font-family: 'Lato' !important;
  }
  .ql-font-Oswald{
          font-family: 'Oswald' !important;
  }

  .ql-font-OpenSans{
          font-family: 'Open Sans' !important;
  }

  .ql-font-SourceSansPro{
      font-family: 'Source Code Pro' !important;
  }
</style>
